import { AppState } from "data/store";
import { AUTH_NS, AuthStatus } from "./types";

export const showLoginWindowSelector = (state: AppState) =>
  (state[AUTH_NS].requireLogin || state[AUTH_NS].showLogin) &&
  state[AUTH_NS].status === AuthStatus.LOGGED_OUT;

export const userSelector = (state: AppState) => state[AUTH_NS].user;
